import React from 'react';
import TheFooter from './footer/TheFooter';
import TheHeader from './header/TheHeader';

const Layout = ({children}) => {
    return (
        <>
            <main className="page-wrapper">
                <TheHeader btnStyle="btn-small round btn-icon" HeaderSTyle="header-not-transparent" />
                {children}
                <TheFooter />
            </main>
        </>
    )
}
export default Layout;
